export default __webpack_public_path__ + "static/media/pr_c_19.cc91be2a.jpg";